export const CONNECTION_STORE  = 'connection';

export interface ConnectionState {
  hasConnection: boolean
}
